import { downloadBlob, getFileExtension } from 'src/utils/file-download.util'
import { getPatientFollowupDocumentFile } from 'src/pages/patients/patient-file/patient-followup/_components/patient-forms/get-patient-followup-document-file'
import { TPatientFollowupDocument } from 'src/pages/patients/patient-file/patient-followup/_components/patient-forms/use-patient-followup-documents.hook'

const downloadPatientFollowupDocument = async (
  document: TPatientFollowupDocument,
  fileName: string,
  patientId: string | number,
  projectId: string | number,
) => {
  const response = await getPatientFollowupDocumentFile(document, patientId, projectId)
  const contentType = response.headers?.['content-type'] as string | undefined

  downloadBlob(
    new Blob([response.data as BlobPart], { type: contentType }),
    `${fileName}.${getFileExtension(contentType)}`,
  )
}

export { downloadPatientFollowupDocument }
